export class BareStore {
    name: string = "";
    address: string = "";
    code: number = 0;
}